import { createSliceSelectors } from 'aria-viewer/core/selectors/utils'

const VideoSelectors = createSliceSelectors('video', [
    'isVideoUIVisible',
    'videoPlayer',
    'videoQualityOptions',
    'videoQuality',
    'videoStartTime',
    'videoVolume',
    'isVideoVolumeMuted',
])

export default VideoSelectors
